import { FocusMonitor } from '@angular/cdk/a11y';
import { ControlValueAccessor, NgControl, Validators, AbstractControl } from '@angular/forms';
import { Optional, Self, Injectable, Input, OnInit, OnDestroy, ElementRef, HostBinding, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { tap, take, takeUntil } from 'rxjs/operators';

export class OgCustomInput implements ControlValueAccessor, OnInit, OnDestroy {
  value: any;
  ngControl: NgControl;
  stateChanges = new Subject<void>();
  focused = false;
  isMaterialFormField = false;
  required: boolean;
  errorState: boolean;
  autofilled?: boolean;
  _userInput: String;
  protected fm: FocusMonitor;
  protected elRef: ElementRef;
  private readonly _destroyed$ = new EventEmitter<void>();
  @HostBinding('attr.aria-describedby') describedBy = '';

  @HostBinding('class.floating')
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  _placeholder;

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(dis) {
    this._disabled = coerceBooleanProperty(dis);
    this.stateChanges.next();
  }
  _disabled = false;

  get empty() {
    return ! this.value && this.value !== false;
  }

  onChange(e) {
    this.propagateChanges(e.target.value);
  }

  propagateChanges = (v) => { };
  propagateTouch = (v) => { };

  constructor(
    ngControl: NgControl,
    fm: FocusMonitor,
    elRef: ElementRef
  ) {
    if (ngControl != null) { this.ngControl = ngControl; this.ngControl.valueAccessor = this; }
    this.fm = fm;
    this.elRef = elRef;
    window.setTimeout(() => {
      this.isMaterialFormField = this.elRef.nativeElement.parentNode.classList.contains('mat-form-field-infix');
    }, 0);
    this.fm.monitor(this.elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }
  ngOnInit() {
    if (this.ngControl) {
      this.ngControl.valueChanges.pipe(
        takeUntil(this._destroyed$)
      ).subscribe((v) => {
        this.writeValue(v);
      }, () => {}, () => {console.log('complete', this); });
    }
  }

  ngOnDestroy() {
    this.fm.stopMonitoring(this.elRef.nativeElement);
    this.stateChanges.complete();
    this._destroyed$.emit();
    this._destroyed$.complete();
  }

  writeValue(obj: any): void {
    if (typeof obj === 'string' || obj === null) {
      this._userInput = obj;
    }
    this.value = obj;
    this.stateChanges.complete();
  }
  checkErrorState() {
    this.errorState = ! this.ngControl.valid;
    this.stateChanges.complete();
  }
  registerOnChange(fn: any): void {
    this.propagateChanges = (v) => {
      this.checkErrorState();
      return fn(v);
    };
    // this.propagateChanges = fn;
  }
  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  setDescribedByIds(ids: string[]): void {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent): void {
    if ((event.target as Element).tagName.toLowerCase() !== 'input') {
      this.elRef.nativeElement.querySelector('input').focus();
      this.propagateTouch(null);
    }
  }
}
